import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ValidateUserAccess } from "../../../network/api/ValidateUserAccess";
import Loader from "../../../components/Loader";

export default function AdminUserWrapper() {

    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const validateUserAccess = async () => {
            const response = await ValidateUserAccess();

            if (response.status === "success" && response.data) {
                setIsAdmin(response.data.super_user);
            } else {
                setIsAdmin(false);
            }

            setIsLoading(false);
        };

        validateUserAccess();
    }, [setIsLoading, setIsAdmin]);


    if (isLoading) {
        return (
            <Loader />
        );
    }

    
    return isAdmin
        ? <Outlet />
        : <Navigate to="/home" state={{ from: location }} replace />;
    
}

